import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const confluencePagesPopupContentEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-confluence-pages-popup-content" */ './index'),
	),
	getPreloadProps: () => ({}),
});
